// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"53":"3ad03d86","297":"5bd4d2e7","328":"8f861723","610":"38fb64a6","852":"34ab317e","893":"bfc6d0da","895":"6ceac444"}[chunkId] + ".chunk.css";
};